import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { EXCLUDED_CHAT_ROUTES } from '../routes/routeMeta';

const TAWK_SCRIPT_URL = 'https://embed.tawk.to/6889f064171f1719311e20b4/1j1dd62ck';

const TawkTo = () => {
  const location = useLocation();

  useEffect(() => {
    const enabled = (process.env.REACT_APP_TAWK_TO_ENABLED ?? 'true') !== 'false';
    const shouldLoadChat = enabled && !EXCLUDED_CHAT_ROUTES.includes(location.pathname);

    if (shouldLoadChat) {
      const existingScript = document.querySelector(`script[src="${TAWK_SCRIPT_URL}"]`);
      if (!existingScript) {
        const s1 = document.createElement('script');
        s1.async = true;
        s1.src = TAWK_SCRIPT_URL;
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        document.body.appendChild(s1);
      }
    } else {
      const existingScript = document.querySelector(`script[src="${TAWK_SCRIPT_URL}"]`);
      if (existingScript) existingScript.remove();
      const tawkContainer = document.getElementById('tawkchat-container');
      if (tawkContainer) tawkContainer.remove();
    }
  }, [location.pathname]);

  return null;
};

export default TawkTo;
